import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.logiqgen.com";
const OG_IMAGE =
  "https://res.cloudinary.com/dzrn93bir/image/upload/f_webp/v1760165405/qq_29_fjuoi1";

const baseKeywords =
  "LogiqGen, AI chatbot development, custom LLM development, build AI chatbot, AI chatbot company, conversational AI platform, enterprise AI solutions, AI automation services, chatbot builder India, custom AI applications, LLM integration services, AI Nestham, EdTech AI";

const ROUTE_SEO = {
  "/": {
    title: "LogiqGen — Build AI Chatbots, Custom LLMs & Intelligent Applications",
    description:
      "LogiqGen builds production-ready AI chatbots, custom LLMs, and enterprise AI integrations. From conversational AI to intelligent automation — we engineer AI that ships. Hyderabad, India.",
    keywords: baseKeywords,
  },
  "/chat": {
    title: "AI Chat Assistant — Try Our Conversational AI | LogiqGen",
    description:
      "Experience LogiqGen's AI chat assistant: intelligent Q&A, guided workflows, and real-time support powered by custom LLMs. See what a production chatbot can do.",
    keywords: `${baseKeywords}, AI chat demo, try AI chatbot, conversational AI demo`,
  },
  "/services": {
    title: "AI Services — Chatbot Development, LLM Fine-Tuning & Enterprise AI | LogiqGen",
    description:
      "End-to-end AI services: custom chatbot development, LLM fine-tuning, enterprise API integrations, intelligent web applications, and AI-powered learning products including AI Nestham.",
    keywords: `${baseKeywords}, AI services, chatbot development services, LLM fine-tuning, AI API integration, enterprise chatbot, AI web applications`,
  },
  "/services/ai-enhanced-websites": {
    title:
      "Build Smarter Websites — AI-Enhanced Sites & Smart Web Apps | LogiqGen",
    description:
      "AI-powered websites and smart apps that automate workflows and personalize experiences. Portfolio: CBR Fin Career, NRI Courier Express, and smart prototypes. Discovery to launch in weeks.",
    keywords: `${baseKeywords}, AI web development, intelligent web applications, AI-enhanced website, custom web app India, conversion-focused website, smart automation`,
  },
  "/services/ai-chatbots-virtual-assistants": {
    title:
      "AI Chatbots & Virtual Assistants — Support, Leads & WhatsApp Bots | LogiqGen",
    description:
      "Custom AI chatbots and virtual assistants: 24/7 support, lead qualification, WhatsApp and messaging bots, CRM integration, and ongoing optimization. Built for startups and enterprises.",
    keywords: `${baseKeywords}, AI chatbot development, virtual assistant for business, WhatsApp chatbot, conversational AI India, customer support automation, lead qualification bot`,
  },
  "/services/custom-llm-development": {
    title:
      "Custom LLM Development — Fine-Tuning, RAG & Private AI Models | LogiqGen",
    description:
      "Build domain-specific LLMs: fine-tuning, RAG, secure private deployment, and integration with your CRM, APIs, and workflows. From strategy to production-ready AI.",
    keywords: `${baseKeywords}, custom LLM development, LLM fine-tuning India, private LLM, RAG system, enterprise AI model, domain-specific language model`,
  },
  "/services/b2b-ai-enterprise-integrations": {
    title:
      "B2B AI Enterprise Integrations — CRM, ERP, Learning Platforms & Analytics | LogiqGen",
    description:
      "Embed AI into CRMs, ERPs, learning platforms, and BI dashboards: workflow automation, predictive analytics, secure APIs, and scalable integration. From analysis to deployment.",
    keywords: `${baseKeywords}, enterprise AI integration, CRM AI integration, ERP automation, AI for business intelligence, B2B AI India, workflow automation enterprise`,
  },
  "/services/ai-personalized-learning": {
    title:
      "AI Personalized Learning — Schools, Colleges & EdTech | LogiqGen",
    description:
      "AI-powered learning platforms, adaptive assessments, AI content generation, and personalized learning paths for K-12, higher education, and EdTech. Built for outcomes and scale.",
    keywords: `${baseKeywords}, AI learning platform, personalized learning platform, adaptive assessment, EdTech AI India, AI in education`,
  },
  "/projects": {
    title: "AI Projects & Case Studies | LogiqGen",
    description:
      "Real AI projects delivered: production chatbots, LLM-powered tools, EdTech platforms, and enterprise AI solutions built for scale by LogiqGen.",
    keywords: `${baseKeywords}, AI case studies, chatbot projects, AI portfolio`,
  },
  "/projects-pro": {
    title: "Our Work — AI Chatbots, Learning Platforms & Web Applications | LogiqGen",
    description:
      "Explore LogiqGen's delivered projects: AI chatbots, learning platforms, custom web applications, and enterprise automation solutions.",
    keywords: `${baseKeywords}, AI projects portfolio, learning platform development, web application development`,
  },
  "/vision": {
    title: "Vision & Mission — Responsible AI for Everyone | LogiqGen",
    description:
      "LogiqGen's vision: accessible AI that empowers businesses and learners. Responsible engineering, strong ethics, and education-first roots driving every solution we build.",
    keywords: `${baseKeywords}, AI vision, responsible AI, AI mission`,
  },
  "/about": {
    title: "About LogiqGen — AI Engineering Team & Leadership",
    description:
      "Meet the LogiqGen team: AI engineers, chatbot developers, and EdTech specialists building production AI from Hyderabad, India. Our mission, values, and leadership.",
    keywords: `${baseKeywords}, about LogiqGen, AI company Hyderabad, AI engineering team`,
  },
  "/contact": {
    title: "Contact LogiqGen — Get AI Chatbot & LLM Development Quotes",
    description:
      "Talk to LogiqGen about building AI chatbots, custom LLMs, enterprise integrations, or AI Nestham partnerships. Free consultation, project scoping, and demos.",
    keywords: `${baseKeywords}, contact AI company, AI chatbot quote, hire AI developers`,
  },
  "/services/ai-iot-automation": {
    title: "AIoT Solutions — AI + IoT Automation for Manufacturing & Smart Systems | LogiQGen",
    description:
      "AI-powered IoT automation for manufacturing, smart homes, and industrial operations. Predictive maintenance, sensor integration, and real-time monitoring from Hyderabad.",
    keywords: `${baseKeywords}, AIoT Hyderabad, AI IoT automation, predictive maintenance, smart manufacturing India, industrial IoT`,
  },
  "/terms-and-conditions": {
    title: "Terms and Conditions | LogiQGen",
    description: "Terms and conditions for using LogiQGen's AI services, website, and products.",
    keywords: `${baseKeywords}, terms and conditions`,
  },
  "/privacy-policy": {
    title: "Privacy Policy | LogiQGen",
    description: "How LogiQGen collects, uses, and protects your personal data. Privacy policy for our AI services and website.",
    keywords: `${baseKeywords}, privacy policy`,
  },
  "/cookie-policy": {
    title: "Cookie Policy | LogiQGen",
    description: "How LogiQGen uses cookies on our website. Cookie policy and your choices.",
    keywords: `${baseKeywords}, cookie policy`,
  },
  "/refund-policy": {
    title: "Refund Policy | LogiQGen",
    description: "LogiQGen's refund and cancellation policy for AI development services.",
    keywords: `${baseKeywords}, refund policy`,
  },
};

function pathToCanonical(pathname) {
  if (pathname === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${pathname.replace(/\/$/, "")}`;
}

/** JSON-LD structured data for rich Google results */
function JsonLdSchemas() {
  const schemas = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: "LogiqGen",
        url: SITE_URL,
        logo: OG_IMAGE,
        description:
          "AI services company building production chatbots, custom LLMs, enterprise AI integrations, and intelligent applications. Education-rooted with products like AI Nestham.",
        foundingDate: "2025",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Hyderabad",
          addressRegion: "Telangana",
          addressCountry: "IN",
        },
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+91-9951293655",
          email: "service@logiqgen.com",
          contactType: "sales",
          availableLanguage: ["English", "Hindi", "Telugu"],
        },
        sameAs: [
          "https://www.linkedin.com/company/logiqgen",
          "https://www.instagram.com/logiqgen",
          "https://github.com/LogiqGen",
          "https://www.youtube.com/@LogiqGen",
        ],
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        url: SITE_URL,
        name: "LogiqGen",
        publisher: { "@id": `${SITE_URL}/#organization` },
        inLanguage: "en",
      },
      {
        "@type": "ProfessionalService",
        "@id": `${SITE_URL}/#service`,
        name: "LogiqGen AI Services",
        url: `${SITE_URL}/services`,
        provider: { "@id": `${SITE_URL}/#organization` },
        serviceType: "AI Development Services",
        description:
          "Custom AI chatbot development, LLM fine-tuning, enterprise AI integrations, and intelligent web application development.",
        areaServed: { "@type": "Country", name: "India" },
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "AI Services",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Custom AI Chatbot Development",
                description:
                  "Production-ready conversational AI chatbots for customer support, sales, internal workflows, and education.",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Custom LLM Development & Fine-Tuning",
                description:
                  "Domain-specific large language models fine-tuned on your data for enterprise applications.",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Enterprise AI Integration",
                description:
                  "AI integration with CRMs, learning platforms, and internal tools via APIs and middleware.",
              },
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "AI-Powered Web Applications",
                description:
                  "Intelligent web applications with AI features: recommendation engines, content generation, and smart automation.",
              },
            },
          ],
        },
      },
      {
        "@type": "SoftwareApplication",
        name: "AI Nestham",
        applicationCategory: "EducationalApplication",
        operatingSystem: "Web",
        url: "https://www.ainestham.com",
        description:
          "Personalized AI learning companion for K-12 students: conversational AI tutoring, adaptive assessments, and gamified learning.",
        offers: {
          "@type": "Offer",
          category: "Educational software",
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Can LogiqGen build a custom AI chatbot for my business?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. LogiqGen builds production-ready AI chatbots for customer support, sales, internal workflows, and education. We handle everything from design to deployment, including integration with your existing systems.",
            },
          },
          {
            "@type": "Question",
            name: "What AI services does LogiqGen offer?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "LogiqGen offers custom chatbot development, LLM fine-tuning, enterprise AI integrations, intelligent web applications, and AI-powered learning products like AI Nestham.",
            },
          },
          {
            "@type": "Question",
            name: "Does LogiqGen build custom LLMs?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. We fine-tune and deploy domain-specific large language models on your data for enterprise use cases — from customer support bots to internal knowledge assistants.",
            },
          },
          {
            "@type": "Question",
            name: "What is AI Nestham?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "AI Nestham is LogiqGen's flagship AI-powered learning platform for K-12 students. It combines conversational AI tutoring, adaptive assessments, and gamified learning for schools in India.",
            },
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}
    />
  );
}

export default function DocumentTitle() {
  const { pathname } = useLocation();
  const meta = ROUTE_SEO[pathname] || {
    title: "LogiqGen — AI Chatbots, Custom LLMs & Smart Applications",
    description:
      "LogiqGen builds AI chatbots, custom LLMs, and enterprise AI solutions from Hyderabad, India.",
    keywords: baseKeywords,
  };
  const canonical = pathToCanonical(pathname);
  const robots = pathname === "/chat" ? "noindex, nofollow" : "index, follow";

  return (
    <>
      <Helmet prioritizeSeoTags>
        <html lang="en" />
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta name="author" content="LogiqGen" />
        <meta name="robots" content={robots} />
        <link rel="canonical" href={canonical} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="LogiqGen" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url" content={canonical} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:alt" content="LogiqGen — AI chatbot and LLM development" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={OG_IMAGE} />
      </Helmet>
      <JsonLdSchemas />
    </>
  );
}
